module.exports = __webpack_public_path__ + "static/avatar_anatoliy_rudenko@2x-0040fb2aa08bb0192af090bf1bce3295.jpg";